<template>
    <div class="gcmcn-card">
        <div class="taker-information-container">
            <div class="taker-information">
                <div>
                    <img :src="taker.logo ? taker.logo : defaultTakerLogo">
                </div>
                <div class="taker-information-name">
                    {{ taker.name}}
                </div>
            </div>
            <div>
                <el-tooltip
                    :disabled="!isConfigured"
                    class="item"
                    effect="dark"
                    content="You can't remove rights when the taker is configured"
                    placement="top"
                >
                    <span>
                        <btn-manage-right
                            :channel-finished="channelFinished"
                            :broadcast-right="relatedBroadcastRight"
                            :channel-confirmed="channelConfirmed"
                            :channel="channel"
                            :is-configured="isConfigured"
                            @create-broadcast-right="createBroadcastRight"
                            @delete-broadcast-right="removeBroadcastRight"
                            @add-profile-broadcast-right="addProfileBroadcastRight"
                        ></btn-manage-right>
                    </span>
                </el-tooltip>
            </div>
        </div>
        <div class="see-more-link" @click="showTaker">
            <i class="el-icon-view"></i>
            <span>SEE MORE</span>
        </div>

        <modal-add-profile-rights
            :filtered-blanking-profile="filteredBlankingProfile"
            :ref="`modal-add-profile-rights-${taker.uid}`"
            :broadcast-right="broadcastRight"
            :taker="taker"
            @create-rights-without-creating-profile="createRightsWithoutProfile"
            @add-taker-profile="addTakerProfile"
        ></modal-add-profile-rights>
    </div>
</template>

<script>
import BtnManageRight from '../../partials/manage-broadcast-right-channels.vue';
import ModalAddProfileRights from './modal-add-profile-rights.vue';
export default {

    components: {
        BtnManageRight,
        ModalAddProfileRights
    },

    props: {
        taker: {
            type: Object,
            required: true,
        },
        broadcastRight: {
            type: Array,
            required: true,
        },
        channelConfirmed: {
            type: Boolean,
            required: true,
        },
        channelFinished: {
            type: Boolean,
            required: false,
            default: false
        },
        filteredBlankingProfile: {
            type: Array,
            required: true,
        },
        channel: {
            type: Object,
            required: true,
        },
        channelConfigurations: {
            type: Array,
            required: true,
        }
    },

    data (){
        return {
            channelConfigured: true,
            hasBroadcastRight: false,
            defaultTakerLogo: '../../../../static/image/default-taker-logo.png'
        };
    },

    computed: {
        relatedBroadcastRight (){
            return this.broadcastRight.find(
                br => br.revoked === false && br.taker_uid === this.taker.uid
            ) || null;
        },
        relatedConfigurations(){
            return this.channelConfigurations.filter(configuration => configuration.taker_uid === this.taker.uid);
        },
        lastConfigurationStatus(){
            let orderedConfigurations = this.relatedConfigurations.sort((a,b) => {
                return new Date(b.creation_date) - new Date(a.creation_date);
            });
            if(orderedConfigurations.length > 0){
                return orderedConfigurations[0].status;
            }
            return '';
        },
        isConfigured(){
            if(this.lastConfigurationStatus === '' || this.lastConfigurationStatus === 'FINISHED'){
                return false;
            }
            return true;
        }
    },

    mounted (){

    },

    methods: {
        addTakerProfile(profile){
            let currentTakersInProfile = profile.takers_uid;
            currentTakersInProfile.push(this.taker.uid);
            this.$store.dispatch('patchItem', {
                item: {
                    takers_uid: currentTakersInProfile,
                    uid: profile.uid,
                    url: profile.url,
                },
                scopes: {'X-Entity-Uid': this.taker.scopes.entity_uid},
                model: 'blankingProfiles'
            }).then(() => {
                this.$emit('create-broadcast-right', this.taker.uid);

            }).catch((e) => {
                console.error(e);
            });
        },
        addProfileBroadcastRight(){
            this.$refs[`modal-add-profile-rights-${this.taker.uid}`].open(this.channel, this.taker);
        },
        showTaker (){
            this.$router.push({
                name: 'takers',
                params: { takerUid: this.taker.uid}
            });
        },
        createBroadcastRight (){
            this.$emit('create-broadcast-right', this.taker.uid);
        },
        createRightsWithoutProfile (){
            this.$emit('create-broadcast-right', this.taker.uid);
        },
        removeBroadcastRight (){
            this.$emit('delete-broadcast-right', this.taker.uid);
        },
    },
};
</script>

<style lang="scss">
.channel-takers{
    .gcmcn-card{
        margin-bottom: 10px;
    }
    .taker-information-container{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .taker-information{
        flex-basis: 70%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .taker-information-name{
            flex-grow: 1;
            margin-left: 30px;
        }
        img{
            flex-basis: 20%;

        }
    }
    img{
        width: 45px;
        height: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Channels/taker.vue